module.exports = __webpack_public_path__ + "static/media/spotlight.en.brand.strapline_Sec.0f76da51.png";